const useRoleInitialStates = () => {
  const roleInitialState = {};

  return {
    roleInitialState
  };
};

export default useRoleInitialStates;
